import { mapEnumToOptions } from '@abp/ng.core';

export enum OnboardingStep {
  Step1_Profile = 0,
  Step2_Address = 1,
  Step3_Wishlist = 2,
  Step4_Share_Twitter = 3,
  Step5_Done = 4,
}

export const onboardingStepOptions = mapEnumToOptions(OnboardingStep);
